import Vue from "vue";
import Vuex from "vuex";
import jsonData from "./modules/jsonData";
import selectedFormIds from "./modules/selectedFormIds";
import product from "./modules/product";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: { jsonData, selectedFormIds, product },
  state: {
    scrollDirection: "",
  },
  mutations: {
    setScrollDirection(state, payload) {
      if (!["scroll-up", "scroll-down"].includes(payload.value)) return;
      state.scrollDirection = payload.value;
    },
  },
  actions: {
    setScrollDirection: ({ commit }, payload) => {
      commit("setScrollDirection", payload);
    },
  },
  getters: {
    scrollDirection(state) {
      return state.scrollDirection;
    },
  },
});
